import React from "react";
import {
  Autocomplete as MuiAutocomplete,
  Box,
  TextField,
  Typography,
} from "@mui/material";
import { colors, borderRadius } from "../../../styles/theme";

interface AutocompleteProps {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  /** Beim Verlassen des Feldes – für Blur-Speichern (siehe docs/adr/004_autosave_dirty_check.md) */
  onBlur?: (value: string) => void;
  /** Erlaubt Werte außerhalb der Optionsliste (Standard: true) */
  freeSolo?: boolean;
  disabled?: boolean;
  readOnly?: boolean;
  required?: boolean;
  error?: string;
  fullWidth?: boolean;
  size?: "small" | "medium";
  sx?: object;
}

/**
 * Freitext-Autocomplete im InputField-Look (Pill-Radius, Schatten).
 * Für reine Auswahl aus fester Optionsliste ohne Freitext siehe Dropdown.
 */
const Autocomplete: React.FC<AutocompleteProps> = ({
  label,
  value,
  options,
  onChange,
  onBlur,
  freeSolo = true,
  disabled = false,
  readOnly = false,
  required = false,
  error,
  fullWidth = true,
  size = "small",
  sx = {},
}) => {
  return (
    <Box sx={sx}>
      <MuiAutocomplete
        freeSolo={freeSolo}
        size={size}
        disabled={disabled}
        readOnly={readOnly}
        fullWidth={fullWidth}
        options={options}
        value={value}
        onInputChange={(_, newValue) => onChange(newValue)}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            required={required}
            error={!!error}
            onBlur={(event) => {
              if (onBlur && !readOnly) onBlur(event.target.value);
            }}
            sx={{
              "& .MuiInputLabel-root": {
                backgroundColor: colors.background.default,
                padding: "0 8px",
                "&.MuiInputLabel-shrink": {
                  backgroundColor: colors.background.default,
                },
              },
              "& .MuiOutlinedInput-root": {
                borderRadius: `${borderRadius.field}px`,
              },
            }}
          />
        )}
      />
      {error && (
        <Typography
          variant="caption"
          color="error"
          sx={{
            mt: 1,
            display: "block",
            fontSize: "0.75rem",
            fontWeight: 400,
            textAlign: "right",
          }}
        >
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default Autocomplete;
